import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Grid, useTheme } from "@mui/material";
import { useEffect, useState } from "react";
import { Layout } from "../../components/Layout/Layout";
import ActionSection from "../../components/LeadDetail/ActionSection/ActionSection";
import AuditSectionTabs from "../lead-details/AuditSectionTab";
import { ActiveLastBreadcrumb } from "../leads/LeadgenerationBreadCrumb";
import "./LeadDetail.scss";
import LeadDetailsTabs from "./LeadDetailsTabs";
import MarkContractStatusCompletedModal from "./MarkContractStatusCompletedModal";
import OfferModal from "./OfferModal";
import SignedDocumentModal from "./SignedDocumentModal";
import LeadsApi from "../../../infrastructure/api/pages/lead-api";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import LeadsObjectApi from "../../../infrastructure/api/pages/lead-object-api";
export const LeadDetail = () => {
    const theme = useTheme();
    const urlParams = new URLSearchParams(window.location.search);
    const myParam = urlParams.get("orderNumber");
    const id = urlParams.get("id");
    const isAffiliate = urlParams.get("isAffiliate") === "true";
    const [modalOpen, setModalOpen] = useState(false);
    const [modalSignedDocOpen, setModalSignedDocOpen] = useState(false);
    const [modalMarkContractCompletedOpen, setModalMarkContractCompletedOpen] = useState(false);
    const [actionTabRefresh, setActionTabRefresh] = useState(false);
    const [refreshModalData, setRefreshModalData] = useState(false); //
    const [refreshObject, setRefreshObject] = useState(false);
    const [refreshActionSection, setRefreshActionSection] = useState(false);
    const [isLeadSpecial, setIsLeadSpecial] = useState(false);
    const [isUnAssignedLead, setIsUnAssignedLead] = useState(false);
    const [leadObjects, setleadObjects] = useState([]);
    const [isObjectLoading, setIsObjectLoading] = useState(false);
    const [lead, setLead] = useState();
    const { t: translate } = useTranslation();
    useEffect(() => {
        if (id) {
            LeadsApi.getLeadByLeadId(id).then((lead) => {
                if (lead.data && lead.status === 200) {
                    setLead(lead.data);
                    if (lead.data.responsiblePersonId === undefined ||
                        lead.data.responsiblePersonId === null) {
                        setIsUnAssignedLead(true);
                    }
                    else {
                        setIsUnAssignedLead(false);
                    }
                }
            });
        }
    }, [id, refreshActionSection]);
    useEffect(() => {
        if (id) {
            setIsObjectLoading(true);
            LeadsObjectApi.getLeadObjectsByid(id)
                .then((response) => {
                if (response.data && response.status === 200) {
                    setleadObjects(response.data);
                }
            })
                .finally(() => { setIsObjectLoading(false); });
        }
    }, [id, actionTabRefresh]);
    const handleOpenModal = () => {
        if (!isUnAssignedLead)
            setModalOpen(true);
        else
            toast.warning(translate("Please assign lead to Sales agent"));
    };
    const handleCloseModal = () => {
        setModalOpen(false);
    };
    const handleOpenSignDocumentModal = () => {
        setModalSignedDocOpen(true);
    };
    const handleCloseSignDocumentModal = () => {
        setModalSignedDocOpen(false);
    };
    const handleOpenMarkContractCompletedModal = () => {
        setModalMarkContractCompletedOpen(true);
    };
    const handleCloseMarkContractCompletedModal = () => {
        setModalMarkContractCompletedOpen(false);
    };
    return (_jsxs(Layout, { children: [_jsx(ActiveLastBreadcrumb, { handleOpenModal: handleOpenModal, handleOpenSignDocumentModal: handleOpenSignDocumentModal, handleOpenMarkContractCompletedModal: handleOpenMarkContractCompletedModal, leadNumber: +myParam, isAffiliate: isAffiliate }), _jsxs(Grid, { container: true, sx: {
                    gap: 2
                }, children: [_jsx(Grid, { container: true, sx: {
                            bgcolor: theme.palette.common.white,
                            borderRadius: "24px",
                            padding: "var(--2, 16px) var(--1, 8px)",
                        }, size: {
                            xs: 12,
                            md: 12,
                            lg: 7
                        }, children: _jsx(Grid, { sx: { justifyContent: "space-between", alignItems: "center" }, size: 12, children: _jsx(LeadDetailsTabs, { refresh: refreshObject, setRefreshModalData: setRefreshModalData, setActionTabRefresh: setActionTabRefresh, leadObjects: leadObjects, isObjectLoading: isObjectLoading }) }) }), _jsxs(Grid, { container: true, sx: {
                            flexDirection: "column",
                            alignItems: "flex-start",
                            gap: "var(--2, 16px)",
                        }, size: {
                            xs: 12,
                            md: 12,
                            lg: 4.7
                        }, children: [_jsx(ActionSection, { leadId: id, refresh: refreshActionSection, setIsLeadSpecial: setIsLeadSpecial, setRefreshData: setRefreshActionSection, lead: lead }), _jsx(Grid, { container: true, sx: {
                                    justifyContent: "center",
                                    bgcolor: theme.palette.common.white,
                                    borderRadius: "24px",
                                    padding: "var(--2, 16px) var(--1, 8px)",
                                    flexDirection: "column",
                                }, size: 12, children: _jsx(AuditSectionTabs, { refresh: refreshModalData }) })] })] }), _jsx(OfferModal, { open: modalOpen, onClose: handleCloseModal, leadId: id, refresh: refreshModalData, setObjectModal: setRefreshObject, leadObjects: leadObjects, setLeadObjects: setleadObjects, setRefreshModalData: setRefreshModalData, setActionTabRefresh: setActionTabRefresh, setStatusSectionRefresh: setRefreshActionSection }), _jsx(SignedDocumentModal, { open: modalSignedDocOpen, onClose: handleCloseSignDocumentModal, leadId: id, refresh: refreshModalData, setObjectModal: setRefreshObject, setRefreshModalData: setRefreshModalData, setActionTabRefresh: setActionTabRefresh, setStatusSectionRefresh: setRefreshActionSection }), _jsx(MarkContractStatusCompletedModal, { open: modalMarkContractCompletedOpen, onClose: handleCloseMarkContractCompletedModal, leadId: id, refresh: refreshModalData, setObjectModal: setRefreshObject, setRefreshModalData: setRefreshModalData, setActionTabRefresh: setActionTabRefresh, setStatusSectionRefresh: setRefreshActionSection })] }));
};
